import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Usuario } from 'src/app/base/domain/usuario.model';
import { QueryOptions } from '../../domain/query.options';
import { LazyLoadEvent } from 'primeng/api';

export interface AcaoEvent {
  acao: string;
  usuario: Usuario;
}

@Component({
  selector: 'app-usuario-list',
  templateUrl: './usuario-list.component.html',
  styleUrls: ['./usuario-list.component.css'],
})
export class UsuarioListComponent implements OnInit {
  @Input() title: string;
  @Input() nomePlaceholder: string;
  @Input() rowsNumber: number;
  @Input() totalRecords: number;
  @Input() loading: boolean;
  @Input() filtros: string[];
  @Input() options: string[];
  @Input() usuarios: Usuario[];

  @Output() novo = new EventEmitter<void>();
  @Output() loadPage = new EventEmitter<number>();
  @Output() acaoClick = new EventEmitter<AcaoEvent>();

  private currentPage = 0;

  queryOptions = new QueryOptions();

  constructor() {}

  ngOnInit(): void {}

  load(event: LazyLoadEvent): void {
    const pageNumber = Math.floor(event.first / event.rows);
    this.currentPage = pageNumber;
    this.loadPage.emit(pageNumber);
  }

  onAcaoClick(acao: string, domain: Usuario): void {
    this.acaoClick.emit({ acao, usuario: domain });
  }

  onAtualizar(): void {
    this.loadPage.emit(this.currentPage);
  }

  onNovo(): void {
    this.novo.emit();
  }
}
